// MyBookingsPageSkeleton.jsx
import "./accountBookingsSkeleton.css";

export default function AccountBookingsSkeleton() {
	return (
		<div className="sf-account-bookings sf-skeleton-bg">

			{/* UPCOMING TITLE */}
			<div className="sf-skel-line sf-skel-title" />

			{/* UPCOMING BOOKING CARDS */}
			<div className="sf-skel-booking-list">
				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className="sf-skel-booking-card">
						<div className="sf-skel-left">
							<div className="sf-skel-line sf-skel-shop" />
							<div className="sf-skel-line sf-skel-date" />
						</div>

						<div className="sf-skel-actions">
							<div className="sf-skel-btn" />
							<div className="sf-skel-btn" />
						</div>
					</div>
				))}
			</div>

			{/* HISTORY TITLE */}
			<div className="sf-skel-line sf-skel-title" style={{ marginTop: "32px" }} />

			{/* HISTORY TABLE */}
			<div className="sf-skel-history-table">
				{Array.from({ length: 3 }).map((_, i) => (
					<div key={i} className="sf-skel-history-row">
						<div className="sf-skel-line sf-skel-col" />
						<div className="sf-skel-line sf-skel-col" />
						<div className="sf-skel-line sf-skel-col" />
						<div className="sf-skel-line sf-skel-col" />
					</div>
				))}
			</div>

		</div>
	);
}
